// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"05db536f","453":"10c18f81","732":"16171590","977":"fac12048"}[chunkId] + ".chunk.js";
};